import styled from "styled-components";

export const StyledPhone = styled.div`
    .phone-main{
        h1{
            font-weight: 700;
            font-size: 48px;
            line-height: 60px;
            margin-bottom: 20px;
        }
        .phone-mode{
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            margin-top: 50px;

            .phone-img{
                width: 35%;
                img{
                    width: 100%;
                }
            }
            .phone-info{
                width: 58%;

                h3{
                    font-weight: 600;
                    font-size: 32px;
                    line-height: 44px;
                }
                .phone-item{
                    display: flex;
                    gap:25px;
                    margin-top: 50px;
                    p{
                        font-weight: 600;
                        font-size: 24px;
                        line-height: 38px;
                        margin-top: -10px;
                    }
                    svg{
                        width: 54px;
                        height: 54px;
                    }
                }
            }
            @media (max-width: 1200px) {
                .phone-img{
                    display: none;
                }
                .phone-info{
                    width: 100%;
                }
            }
            @media (max-width: 576px) {
                .phone-info{
                    h3{
                        font-size: 16px;
                        line-height: 24px;
                    }
                    .phone-item{
                        margin-top: 20px;
                        gap: 10px;
                        p{
                            font-size: 13px;
                            line-height: 19px;
                        }
                        svg{
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
            }
        }
    }

    .phone-user{
        margin-top: 50px;
        .manual-main{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .manual-list{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 55%;
                .manual-items{
                    margin-bottom: 80px;
                }

                .manual-item{
                    margin-top: 50px;
                    display: flex;
                    gap:25px;

                    h3{
                        font-weight: 600;
                        font-size: 24px;
                        line-height: 33px;
                    }
                    p{
                        line-height: 26px;
                        color: #6C6C6C;
                    }
                }
                @media (max-width:576px) {
                display: block;
                .manual-item{
                    width: 100%;
                    margin-top: 20px;
                    gap:10px;
                        h3{
                            font-size: 16px;
                            line-height: 24px;
                        }
                        p{
                            font-size: 13px;
                            line-height: 19px;
                        }
                        svg{
                            width: 24px;
                            height: 24px;
                        }
                }
            }
                
            }
            .manual-bottom{
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
            }

            .manual-img{
                width: 35%;
                .samsung{
                    width: 100%;
                }
            }

            @media  (max-width: 1200px) {
                .manual-bottom{
                    display: none;
                }
                .manual-list{
                    .manual-items{
                        margin-bottom: 0;
                    }
                }
            }
            @media (max-width: 992px) {
                flex-direction: column-reverse;
                .manual-list{
                    width: 100%;
                }
                .manual-img{
                    width: 80%;
                    margin: 0 auto;
                }
            }
            @media (max-width: 576px) {
                .manual-img{
                    width: 100%;
                }
            }
        }
        
    }
    @media (max-width: 576px) {
       .phone-main h1{
            font-size: 32px;
            line-height: 40px;
        }
    }
`